import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PatientsComponent } from './patients.component';
import { PSubscriptionComponent } from './subscription/p-subscription/p-subscription.component';
import { MediConsultComponent } from './Telemedicine-Section/medi-consultant/medi-consult.component';
import { AmbulanceComponent } from './Ambulance-Section/ambulance/ambulance.component';
import { AmbulanceBookComponent } from './ambulance-book/ambulance-book.component';
import { BookTeleMedicineComponent } from './book-tele-medicine/book-tele-medicine.component';
import { MediConsultDetailComponent } from './Telemedicine-Section/medi-consultant-detail/medi-consult-detail.component';
import { AuthGuard } from '../../guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: PatientsComponent,
    children: [
      {
        path: 'patient-dashboard',
        loadChildren: () =>
          import('./patient-dashboard/patient-dashboard.module').then(
            (m) => m.PatientDashboardModule,
          ),
      },
      {
        path: 'profile-settings',
        loadChildren: () =>
          import('./profile-settings/profile-settings.module').then(
            (m) => m.ProfileSettingsModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'ambulance-book',
        component: AmbulanceBookComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'consult-now',
        component: BookTeleMedicineComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'tele-consult',
        component: MediConsultComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'tele-consult-detail',
        component: MediConsultDetailComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'ambulance',
        component: AmbulanceComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'dependent',
        loadChildren: () =>
          import('./manage-family-member/family-member.module').then(
            (m) => m.FamilyMemberModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'subscription',
        component: PSubscriptionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'payment',
        loadChildren: () =>
          import('./payment/payment.module').then((m) => m.PaymentModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'medical-records',
        loadChildren: () =>
          import('./medical-records/medical-records.module').then(
            (m) => m.MedicalRecordsModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'maisha-health-ai',
        loadChildren: () =>
          import('./maisha-health-ai/maisha-health-ai.module').then(
            (m) => m.MaishaHealthAiModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'video-room/:roomName',
        loadComponent: () =>
          import('./video-calling-room/calling-room.component').then(
            (m) => m.CallingRoomComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'audio-room/:roomName',
        loadComponent: () =>
          import('./audio-calling-room/audio-calling-room.component').then(
            (m) => m.AudioCallingRoomComponent,
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PatientsRoutingModule {}
